import React, { createContext, useEffect, useState } from "react";

import config from "../modules/users/config.json";

import { getData } from "../services/API";
import { getItemStorage } from "../Localstorage/useLocalStorage";

export const UserData = createContext();

const UserInfoContext = ({children}) => {
  const {
    api_url: { g_user_profile },
  } = config;

  const [user, setUser] = useState({});
  const [userLoaded, setUserLoaded] = useState(false)
  const [data, setData] = useState({})
  const [err, setErr] = useState({})

  const token = getItemStorage("token")

  useEffect(() => {
    if (token) {
      getData(g_user_profile.url, {}, true)
        .then((res) => {
          setUser(res.data)
          setData(res)
          setUserLoaded(true)
        })
        .catch((err) => {
          setUser(err.response)
          setUserLoaded(true)
          setErr(err)
          setData(err)
        });
    }
  }, [token]);

  return <UserData.Provider value={{user, setUser, userLoaded, err}}>{children}</UserData.Provider>;
};

export default UserInfoContext;
